import React, { useState } from "react";
import "./login.css";
import { AuthShell } from "../auth/AuthBackground";
import { useNavigate } from "react-router-dom";
import { alertToast } from "../../alertToast";
import { useEffect } from "react";
import Base_Url from "../../config";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { CiLock } from "react-icons/ci";
import { CiMobile3 } from "react-icons/ci";

export const Login = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/home");
    }
  }, [navigate]);

  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const response = await fetch( `${Base_Url}/auth/signin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emailOrPhone,
          password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        alertToast("Login successful!", "success"); // Show success toast

        setTimeout(() => {
          navigate("/home");
        }, 1500);
      } else {
        alertToast("Invalid credentials. Please try again.", "error"); // Show error toast
      }
    } catch (error) {
      alertToast("An error occurred while logging in.", "error"); // Show error toast
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell>
      <h1 className="ic-auth-title">Welcome back</h1>
      <p className="ic-auth-sub">
        Sign in to your Interlink account.
      </p>
      <form onSubmit={handleSignIn}>
        <div className="ic-field">
          <label htmlFor="emailOrPhone">Phone number</label>
          <span className="ic-ico"><CiMobile3 /></span>
          <input
            type="tel"
            inputMode="tel"
            required
            className="ic-input"
            id="emailOrPhone"
            placeholder="Enter your phone number"
            autoComplete="username"
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
          />
        </div>
        <div className="ic-field">
          <label htmlFor="password">Password</label>
          <span className="ic-ico"><CiLock /></span>
          <input
            type={isPasswordVisible ? "text" : "password"}
            className="ic-input"
            id="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="ic-eye"
            aria-label={isPasswordVisible ? "Hide password" : "Show password"}
            aria-pressed={isPasswordVisible}
            onClick={togglePasswordVisibility}
          >
            {isPasswordVisible ? <MdOutlineRemoveRedEye /> : <AiOutlineEyeInvisible />}
          </button>
        </div>
        <button type="submit" className="ic-btn" disabled={isSubmitting} aria-busy={isSubmitting}>
          {isSubmitting ? "Signing in…" : "Log in"}
        </button>
        <div className="ic-links">
          <button type="button" className="ic-link" onClick={() => navigate("/forgotPassword")}>
            Forgot password?
          </button>
          <button type="button" className="ic-link" onClick={() => navigate("/register")}>
            Create account
          </button>
        </div>
      </form>
    </AuthShell>
  );
};
